import { state } from '../map_state/state'
import { importExportTool } from './import_export_tool'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { edgeDistanceTool } from './edge_distance_tool'
import { cropTool } from './crop_tool'

class SwapTool {
  constructor () {
    this.element = document.getElementById('mct-replace-map')
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.swap = this.swap.bind(this)
    this.element.addEventListener('click', this.swap)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.swap)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 's' && !this.element.classList.contains('hidden')) {
      callMethodOnKeydown(e.target, this.swap)
    }
  }

  swap () {
    if (!state.mapImage) return
    if (state.cropMode) cropTool.activate(false)
    if (state.edgeDistanceMode) edgeDistanceTool.activate(false)
    state.swapMode = true
    importExportTool.field.click()
  }

  toggleVisibility () {
    this.element.classList.toggle('hidden', !state.mapImage)
  }
}

export let swapTool = null

export function initSwapTool () {
  swapTool = new SwapTool()
  return swapTool
}
